import React from 'react';
import {Redirect} from 'react-router-dom';

import APPCONFIG from "constants/Config";
import Framework from "@beardeddevops/react.framework";
import {Collections} from "components";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/dashboard',
		icon: 'dashboard',
	},
	{
		name: 'Firearms',
		url: '/products',
		icon: 'barcode',
	}
];

class Products extends Framework.Components.View {
	render() {
		if (!this.props.rootState.ffl_boss_linked) {
			return <Redirect to="/dashboard" />;
		}

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}/>

				<Framework.Errors.General isDev={APPCONFIG.settings.isDev()}>
					<Collections.Products
						history={this.props.history}
						reloadParent={this.props.reloadParent}
					/>
				</Framework.Errors.General>
			</div>
		);
	}
}

export default Framework.Components.withRootState(Products);
